/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import clsx from 'clsx';
import { ListItem } from '@trdk/style/List';
import {
  withStyles,
  Button, Typography, TablePagination, TextField,
  Tooltip, Grid, Hidden, Tabs, Tab, List, Divider,
} from '@material-ui/core';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemText from '@material-ui/core/ListItemText';
import NotificationBar from '@trdk/style/NotificationBar';
import { doFetch, fetchClear } from '../../../services/fetch/fetch.actions';
import { fetchParty, postActivateParty } from '../../../services/admin/party-service';
import Dialog from '../../../components/dialog';

class PartyMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      currentRowPerPage: 10,
      search: '',
      openDialog: false,
      selectedTable: 0,
    };
  }

  componentDidMount() {
    const {
      match: { params: { id } },
      dispatch,
      history,
    } = this.props;
    dispatch(doFetch(
      'GET_PARTY',
      fetchParty(id)
        .then((res) => {
          if (!res.ok) {
            history.push('/admin/partier');
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  deactivateParty = (id, status) => {
    const { dispatch, history } = this.props;
    dispatch(doFetch(
      'ACTIVATE_PARTY',
      postActivateParty(id, status)
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res;
        }).then((r) => {
          dispatch(fetchClear('PARTIES'));
          dispatch(fetchClear('PARTIES_NAME'));
          history.push('/admin/partier');
          return r;
        }),
    ));
  }

  render() {
    const {
      classes,
      currentParty: {
        error: fetchError, fetching, payload: { Resources: data }, fetched,
      }, history,
      activateParty: { error: activateError },
    } = this.props;
    const {
      currentPage, currentRowPerPage, search, openDialog, selectedTable,
    } = this.state;

    const options = [5, 10, 25, 100];
    const min = currentPage * currentRowPerPage;
    const max = min + currentRowPerPage - 1;

    const party = (data != null) ? data : '';

    const members = party != null && party.members != null ? party.members
      // .filter(item => !item.pending)
      .filter(item => (`${(`${item.givenName} ${item.familyName}`).toLowerCase()}`)
        .includes(search.toLowerCase()) || search === '') : [];

    let pagination = [];
    if (fetched && !fetchError) {
      pagination = members.filter(item => (
        item.pending ? selectedTable === 1 : selectedTable === 0
      ));
    }

    const list = pagination.filter((item, i) => i <= max && i >= min);

    return (
      <div className={classes.root}>
        <Grid container spacing={1} direction="row" justify="space-between">
          {party.active
            && (
              <Hidden smUp>
                <Grid item xs={12} sm={6}>
                  {!(list.length === 0 && (party.members === undefined || party.members.length === 0)) ? (
                    <Typography variant="subtitle2" className={classes.disabledDeactivateText}>
                      Deaktiver parti
                    </Typography>
                  ) : (
                    <Typography variant="subtitle2" className={classes.deactivateText} onClick={() => this.setState({ openDialog: true })}>
                      Deaktiver parti
                    </Typography>
                  )}

                </Grid>
              </Hidden>
            )}
          <Grid item xs={12} sm={6}>
            <Typography variant="h4" color="primary">
              {`Politikere i ${party.display ? party.display : 'parti'}`}
            </Typography>
          </Grid>
          {party.active
          && (
            <Hidden xsDown>
              <Grid item xs={12} sm={6} className={classes.buttongrid}>
                <Tooltip title={fetching || !(list.length === 0
                && (party.members === undefined || party.members.length === 0))
                  ? 'Kan ikke deaktivere partiet fordi det inneholder medlemmer.' : ''}
                >
                  <div>
                    <Button
                      variant="contained"
                      disabled={fetchError || fetching || !(list.length === 0
                        && (party.members === undefined || party.members.length === 0))}
                      className={classes.button}
                      onClick={() => this.setState({ openDialog: true })}
                    >
                      Deaktiver parti
                    </Button>
                  </div>
                </Tooltip>
              </Grid>
            </Hidden>
          )}
        </Grid>
        <div className={classes.flex}>
          <TextField
            className={classes.search}
            label="Søk etter politiker (navn)"
            margin="dense"
            value={search}
            onChange={e => this.setState({ search: e.target.value })}
          />
        </div>
        <Tabs
          className={classes.tabs}
          value={selectedTable}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, value) => {
            this.setState({ selectedTable: value, currentPage: 0 });
          }}
        >
          <Tab label="Aktive" className={classes.tab} />
          <Tab label="Til godkjenning" className={classes.tab} />
        </Tabs>

        {!fetchError ? (
          <div>
            <List key={1} component="nav" disablePadding>
              <Divider />
              {list.length > 0 && list
                .map(({
                  givenName, familyName, id,
                }, i) => [
                  <MuiListItem key={id} className={clsx(i % 2 !== 0 && classes.odd, classes.listitem)} divider button onClick={() => history.push(`/admin/users/id-${id}`)}>
                    <MuiListItemText primary={`${givenName} ${familyName}`} />
                  </MuiListItem>,
                ])}
              {fetching && Object.keys(Array(5).fill(0))
                .map(val => (
                  <ListItem
                    key={`skel-${val}`}
                    primary={<Skeleton />}
                    secondary={<Skeleton />}
                  />
                ))
              }
              {!fetching && list.length === 0 && party.members && party.members.length > 0 && (
                <MuiListItem divider><MuiListItemText primary="Ingen politikere i partilisten" secondary="Prøv å søk noe annet eller se annen liste" /></MuiListItem>
              )}
              {!fetching && list.length === 0 && (party.members === undefined || party.members.length === 0) && (
                <MuiListItem divider><MuiListItemText primary="Ingen politikere i partiet, ønsker du å deaktivere partiet?" secondary="" /></MuiListItem>
              )}
            </List>
            {!fetching && list.length > 0 && [
              <Hidden xsDown key="hidden1">
                <TablePagination
                  component="nav"
                  page={currentPage}
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} av ${count}`}
                  labelRowsPerPage="Politikere per side"
                  rowsPerPage={currentRowPerPage}
                  rowsPerPageOptions={options}
                  count={members.length}
                  onChangePage={(e, page) => this.setState({ currentPage: page })}
                  onChangeRowsPerPage={e => this.setState({ currentRowPerPage: e.target.value, currentPage: 0 })}
                />
              </Hidden>,
              <Hidden smUp key="hidden2">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body1" className={classes.showingtext}>
                      {`Viser side ${currentPage + 1} av ${Math.ceil((members.length) / currentRowPerPage)}`}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => this.setState({ currentPage: currentPage - 1 })}
                      disabled={currentPage === 0}
                      fullWidth
                    >
                      Forrige side
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      disabled={(currentPage + 1) >= (members.length) / currentRowPerPage}
                      onClick={() => this.setState({ currentPage: currentPage + 1 })}
                    >
                      Neste side
                    </Button>
                  </Grid>
                </Grid>
              </Hidden>,
            ]}
          </div>
        ) : (
          <NotificationBar message="Feil ved henting av politikere i partiet" variant="error" />
        )}
        <div className={classes.flex}>
          <Button color="primary" variant="outlined" className={classes.backBtn} onClick={() => { history.push('/admin/partier'); }}>
            Tilbake
          </Button>
        </div>

        <Dialog
          key="deactivate"
          title="Deaktiver parti"
          text={`Ønsker du å deaktivere ${party.display || party.name}?`}
          open={openDialog}
          handleClose={() => this.setState({ openDialog: false })}
          handleAccept={() => this.deactivateParty(party.id, false)}
          agreeButton="Deaktiver"
          noTimer
        />
        {activateError && <NotificationBar message={`Feil ved deaktivering av partiet: "${activateError}"`} variant="error" />}
      </div>
    );
  }
}

const styles = theme => ({
  mb: {
    marginBottom: '0.5rem',
  },
  flex: {
    display: 'flex',
    alignItems: 'bottom',
    marginBottom: '1rem',
    flexWrap: 'wrap-reverse',
  },
  backBtn: {
    marginTop: '2rem',
  },
  root: {
    maxWidth: '60rem',
    marginBottom: '4rem',
  },
  odd: {
    backgroundColor: '#f7f7f7',
  },
  listitem: {
    '&:hover, &:focus': {
      borderLeft: `0.2rem solid ${theme.palette.primary.main}`,
    },
    borderLeft: '0.2rem solid transparent',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6rem',
    },
  },
  search: {
    minWidth: '17rem',
  },
  tooltip: {
    marginTop: '2rem',
    marginLeft: '1rem',
  },
  showingtext: {
    color: '#808080',
    marginTop: '1rem',
  },
  buttongrid: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    '&:hover': {
      backgroundColor: '#f00',
      color: '#fff',
    },
    marginRight: '1rem',
  },
  deactivateText: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
  },
  disabledDeactivateText: {
    color: 'rgba(0, 0, 0, 0.26)',
    textDecoration: 'underline',
  },
  tabs: {
    minHeight: '2rem',
  },
  tab: {
    maxHeight: '3rem',
    minHeight: 0,
  },
});

PartyMembers.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.any.isRequired,
  currentParty: PropTypes.object.isRequired,
  activateParty: PropTypes.object.isRequired,
};

const mapStateToProps = ({ currentParty, activateParty }) => ({ currentParty, activateParty });

export default connect(mapStateToProps)(withStyles(styles)(PartyMembers));
